/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettingsDto } from '../../models/settings-dto';

export interface GetSettingsForBp$Params {
  type: string;
  bpGuid: string;
}

export function getSettingsForBp(http: HttpClient, rootUrl: string, params: GetSettingsForBp$Params, context?: HttpContext): Observable<StrictHttpResponse<SettingsDto>> {
  const rb = new RequestBuilder(rootUrl, getSettingsForBp.PATH, 'get');
  if (params) {
    rb.path('type', params.type, {});
    rb.path('bpGuid', params.bpGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SettingsDto>;
    })
  );
}

getSettingsForBp.PATH = '/settings/{type}/bp/{bpGuid}';
